export default __webpack_public_path__ + "static/media/BCA3.493e34ee.jpg";